import defaultSite from '../defaultSite';
import lamanteSite from '../lamanteSite';
import { SiteDefinition } from '../SiteDefinition';

const registry: Record<string, SiteDefinition> = {
    [defaultSite.id]: defaultSite,
    [lamanteSite.id]: lamanteSite,
};

export default registry;
